import React from "react";
import { css } from "@linaria/core";
import { colors } from "@ui/Theme";
import t from "@ui/i18n";
import { fonts } from "@ui";

const layout = css`
  font: ${fonts.body1};
  color: ${colors.carbon800};
`;

export const FlagChartTooltip = ({ flags }: { flags: { name: string; description: string }[] }) =>
  flags.length > 0 ? (
    <ul>
      {flags.map(flag => (
        <li key={flag.name} className={layout}>
          {t("highcharts.tooltip.flag.description", flag)}
        </li>
      ))}
    </ul>
  ) : null;
